import { useParams } from "react-router-dom";
import { OrderByType, useGenericAPI, useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import { BConnector, BConnectorPatch } from "../types/stations.types";
import { BASE_URL_CONNECTOR, BASE_URL_STATION } from "../services/stationsAPI";
import useQueryURL from "../../../common/hooks/useQueryURL";

export interface UseConnectorsConfig {
  stationId?: string | null;
  chargePointId ?: string | null;
  pageSize?: number;
  orderBy?: OrderByType<BConnector>;
}

/**
 * useConnectors 
 *
 * @param config 
 * @returns 
 */
export default function useConnectors(config: UseConnectorsConfig) {

  const {stationId, chargePointId} = useParams();
  const {getQueryValue} = useQueryURL()
  const chargePointIdUrl = (getQueryValue("chargePointId") === "")   ? undefined : getQueryValue("chargePointId");


  const stationIdFound = config.stationId || stationId;
  const chargePointIdFound = config.chargePointId || chargePointId || chargePointIdUrl;

  const baseURL = BASE_URL_STATION + "/" + stationIdFound + "/chargepoints/" + chargePointIdFound  + "/connectors";
  
  if (!stationIdFound) {
    console.error("No stationId found");
  }

  const {createNew, getAllQuery} = useGenericAPI<BConnector, BConnectorPatch, BConnectorPatch>({
    baseURL: baseURL,
    APIname: "connectors",
    queryKey:["connectors-"+chargePointIdFound],
    pageSize: config.pageSize,
    orderBy: config.orderBy || "-b_connector_created_at",
    disableGet: !chargePointIdFound  || !chargePointIdFound,
    onSucessRefetchRessources: ["chargepoints", "connectors"],
  })

  return {
    stationIdFound,
    chargePointIdFound,
    getAllConnectorsQuery: getAllQuery,
    createNewConnectorQuery: createNew
  }
}


export interface UseSingleConnectorConfig {
  connectorId?: string;
  chargePoint?: string;
  StationId?: string;
}

/**
 * useSingleConnector 
 *
 * @param config 
 * @returns 
 */
export function useSingleConnector(config: UseSingleConnectorConfig) {
  
  const {stationId, chargePointId, connectorId} = useParams();
  const {getQueryValue} = useQueryURL()
  const connectorIdUrl = (getQueryValue("single-connector-id") === "")   ? undefined : getQueryValue("connectorId");

  const stationIdFound = config.StationId || stationId;
  const chargePointIdFound = config.chargePoint || chargePointId;
  const connectorIdFound = config.connectorId || connectorId || connectorIdUrl || undefined;

  if (!stationIdFound) {
    console.error("No stationId found");
  }

  if (!chargePointIdFound) {
    console.error("No borneId found");
  }

  if (!connectorIdFound) {
    console.error("No connectorId found");
  }

  const baseURL = BASE_URL_STATION + "/" + stationIdFound + "/chargepoints/" + chargePointIdFound + "/connectors";

  const { singleQuery, updateQuery, deleteQuery, patchQuery} = useSingleGenericAPI<BConnector, BConnectorPatch>({
    baseURL: baseURL,
    APIname: "connectors",
    id: connectorIdFound || "",
    disableGet: !stationIdFound || !chargePointIdFound || !connectorIdFound,
    onSucessRefetchRessources: ["chargepoints", "connectors"],
  })

  const convertPricetokWh = (amountPrice: number) =>  {

    if (!singleQuery.data ||
      !singleQuery.data.b_connector_price_per_kwh ||
      singleQuery.data.b_connector_price_per_kwh === 0
    ) {
      return null
    }

    const nbKWh = amountPrice / singleQuery.data.b_connector_price_per_kwh ;

    return parseFloat(nbKWh.toFixed(2));
  }
  return {
    connectorIdFound,
    stationIdFound,
    chargePointIdFound,
    getSingleConnectorQuery: singleQuery,
    updateSingleConnectorQuery: updateQuery,
    deleteSingleConnectorQuery: deleteQuery,
    patchSingleConnectorQuery: patchQuery,
    convertPricetokWh,
  }
}


/**
 * useSingleConnector 
 *
 * @param config 
 * @returns 
 */
export function useSingleConnectorV2(config: UseSingleConnectorConfig) {
  
  const {connectorId} = useParams();
  const {getQueryValue} = useQueryURL()
  const connectorIdUrl = (getQueryValue("single-connector-id") === "")   ? undefined : getQueryValue("connectorId");

  const connectorIdFound = config.connectorId || connectorId || connectorIdUrl;

  if (!connectorIdFound) {
    console.error("No connectorId found");
  }

  const baseURL = BASE_URL_CONNECTOR

  const { singleQuery, updateQuery, deleteQuery, patchQuery} = useSingleGenericAPI<BConnector, BConnectorPatch>({
    baseURL: baseURL,
    APIname: "connectors",
    id: connectorIdFound || "",
    disableGet: !connectorIdFound,
    onSucessRefetchRessources: ["connectors", "chargepoints"],
  })

  const convertPricetokWh = (amountPrice: number): (null | number) =>  {

    if (!singleQuery.data ||
      !singleQuery.data.b_connector_price_per_kwh ||
      singleQuery.data.b_connector_price_per_kwh === 0
    ) {
      return null
    }

    const nbKWh = amountPrice / singleQuery.data.b_connector_price_per_kwh ;

    return parseFloat(nbKWh.toFixed(2));
  }
  return {
    connectorIdFound,
    singleConnectorQuery: singleQuery,
    updateSingleConnectorQuery: updateQuery,
    deleteSingleConnectorQuery: deleteQuery,
    patchSingleConnectorQuery: patchQuery,
    convertPricetokWh
  }
}